import { ObterDadosPlanoPagamentoResposta } from "app/api/classes/OrcamentoApi"
import microuniversoApi from "app/api/microuniversoApi"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact"
import { useAppSelector } from "app/redux/hooks"
import { Carencia, NumeroParcelas } from "app/types/AbaPlanoPagamento"
import React, { useEffect, useState } from "react"
import { PlanoDePagamentoContainer } from "../PlanoDePagamentoContainer"
import { TelaFormaDePagamentoContainer } from "../TelaFormaDePagamentoContainer"
import { SimularFinanciamento, SimularFinanciamentoFormulario } from "./SimularFinanciamento"

export const SimularFinanciamentoContainer = () => {
    const [dadosSimulacaoFinanciamento, setDadosSimulacaoFinanciamento] = useState<SimularFinanciamentoFormulario>({})
    const [numerosParcelas, setNumerosParcelas] = useState<NumeroParcelas[]>([])
    const [carencias, setCarencias] = useState<Carencia[]>([])
    const [informacoesPlanosPagamento, setInformacoesPlanosPagamento] = useState<ObterDadosPlanoPagamentoResposta>(null)

    const orcamento = useAppSelector(state => state.orcamento)

    const atualizarInformacoesPlanosPagamento = async () => {
        const informacoesPlanoAtualizadas = await microuniversoApi.Orcamento.obterDadosPlanoPagamento(orcamento.IdentificadorOrcamento)

        if ("HasErrors" in informacoesPlanoAtualizadas) {
            setInformacoesPlanosPagamento(informacoesPlanosPagamentos => ({
                ...informacoesPlanosPagamentos,
                ParcelasPlanoPagamento: [],
                Carencias: []

            }))
            return
        }

        setInformacoesPlanosPagamento(informacoesPlanoAtualizadas)
    }

    const planoPagamentoModificado = async (codigoPlanoPagamento:string) => {
        setNumerosParcelas(
            await microuniversoApi.Orcamento.listarParcelasPlanoPagamentoPorCodigo(codigoPlanoPagamento)
        )
    }

    const numeroParcelasModificado = async (codigoNumeroParcelas:number) => {
        setCarencias(
            await microuniversoApi.Orcamento.listarCarenciasParcelaPlanoPagamentoPorCodigo(codigoNumeroParcelas)
        )
    }

    const renderizarTelaFormaDePagamentoContainer = () => renderizarComponentReact(
        <TelaFormaDePagamentoContainer
            somenteLeitura={orcamento.SomenteLeitura}
            abaSelecionada="Plano de Pagamento" />,
        "conteudo-pagina",
        true
    )

    const simularFinanciamento = async (dados: SimularFinanciamentoFormulario) => {
        setDadosSimulacaoFinanciamento(
            await microuniversoApi.Orcamento.simularFinanciamento(dados)
        )
    }

    useEffect(() => {
        atualizarInformacoesPlanosPagamento()
    },[])

    return <>
        <Breadcrumb2Container
            exibirBotaoLimpar={false}
            exibirBotaoVoltar={true}
            id="breadcrumb-simular-financiamento"
            onBotaoVoltarClicado={renderizarTelaFormaDePagamentoContainer} 
            passos={["Formas de Pagamento", "Simular Financiamento"]}
            onPassoSelecionado={passo => {
                if (passo == "Formas de Pagamento") {
                    renderizarTelaFormaDePagamentoContainer()
                }
            }}/>
        <SimularFinanciamento 
            simularFinanciamentoFormulario={dadosSimulacaoFinanciamento} 
            planosPagamento={informacoesPlanosPagamento?.PlanosPagamento ?? []} 
            numerosParcelas={numerosParcelas} 
            carencias={carencias} 
            onCalcular={simularFinanciamento} 
            onErrorValidacao={() => {}} 
            valorAtivadoDefault={false}
            onPlanoPagamentoSelecionado={planoPagamentoModificado}
            onNumeroParcelasModificado={numeroParcelasModificado}/>
    </>
}